/* global ZAGFramework */

(function ($) {

    this.init = function () {
        this.SkipLinks();
    };

    /****************************************************************
     SPEEDBUMP
    ****************************************************************/

    this.SkipLinks = function () {

        $("#OLBSkip").on("click", function () {
            if ($(window).outerWidth() < 991) {
                $(".onlinebanking-content-link").focus();
            } else {
                $("#onlineBankingType").focus();
            }
            if ($('.olb-launch').length) {
                var signInButton = $('a.primary-button.headernav-desktop-global-bottom-login.olb-launch');
                signInButton.focus();
            }
        });

        $('a[href^="#MainContent"]').on('click', function (event) {
            var href = $(this).attr('href');
            if (href.charAt(0) === '#') {
                event.preventDefault();
                var target = $(href);
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function () {
                    target.attr('tabindex', '-1').focus();
                });
            }
        });

    }
    this.init();

})(jQuery);